import { gql } from '../types/generated';

export const ADJUST_MILESTONE_TIME = gql(`
  mutation adjustMilestoneTime($mediaId: String!, $milestoneId: String!, $timestamp: String!) {
    adjustMilestoneTime(mediaId: $mediaId, milestoneId: $milestoneId, timestamp: $timestamp) {
      id
      milestoneType
      title
      absoluteTime
      updatedBy
      keywords {
        name
        value
      }
    }
  }
`);

export const DELETE_MILESTONE = gql(`
  mutation deleteMilestone($mediaId: String!, $milestoneId: String!) {
    deleteMilestone(mediaId: $mediaId, milestoneId: $milestoneId)
  }
`);

export const INSERT_MILESTONE = gql(`
  mutation insertMilestone($mediaId: String!, $milestoneInput: MilestoneInput!) {
    insertMilestone(mediaId: $mediaId, milestoneInput: $milestoneInput) {
      id
      title
      milestoneType
      updatedBy
      keywords {
        name
        value
      }
    }
  }
`);

export const INITIATE_TRIM = gql(`
  mutation initiateTrim($mediaId: String!, $newStartTime: String!, $newEndTime: String!) {
    initiateTrim(
      mediaId: $mediaId
      newStartTime: $newStartTime
      newEndTime: $newEndTime
    ) {
      mediaId
      success
      reason
    }
  }
`);
